import styled from 'styled-components';
import mapFullscreen from '../assets/mapbox-fullscreen.svg';
import color from '../constants/color';
import { defaultLineHeightRatio } from '../constants/font';
import { px } from '../utils/px';
import Block from './generic/Block';

const MapContainer = styled(Block)`
  .mapboxgl-ctrl-icon:focus {
    border: ${px(1)} solid ${color.link};
  }
  
  .pointMarker {
    cursor: pointer;
  }

  .clusterMarker {
    cursor: pointer;
  }
  
  .collectionPointPopup {
    line-height: ${defaultLineHeightRatio};
  
    .mapboxgl-popup-content {
      padding: ${px(10)} ${px(20)};
      box-shadow: 0 ${px(3)} ${px(13)} 0 rgba(0, 0, 0, 0.35);
      
      .mapboxgl-popup-close-button {
        color: #69687e;
        font-size: ${px(22)};
        // margin-right: ${px(5)};
        width: ${px(30)}
      }
    }
  }
  
  .mapboxgl-ctrl-icon.mapboxgl-ctrl-fullscreen {
    background-image: url(${mapFullscreen});
    background-repeat: no-repeat;
}
`;

export default MapContainer;
